import { MysteryCampaignModel } from './../../shared/models/mystery-shopper';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';

@Component({
  selector: 'app-mysteryshopper-whitelist-outlets',
  templateUrl: './mysteryshopper-whitelist-outlets.component.html',
  styleUrls: ['./mysteryshopper-whitelist-outlets.component.scss']
})
export class MysteryshopperWhitelistOutletsComponent implements OnInit {
  mysteryCampaign: MysteryCampaignModel[];
  getPaginationCount;
  page: any = 1;
  formGroup;
  deletePopupUiData;
  addOrEditLanguage: string;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: Router,
    public alertService: AlertService
  ) { }

  ngOnInit() {
    this.getAllMysteryCampaign();
  }

  getAllMysteryCampaign() {
    this.apiService.getHeaders(this.apiConfig.getAllMysteryCampaign + "?page=" + this.page)
      .subscribe((res: any) => {
        this.mysteryCampaign = res.body.data;
        this.getPaginationCount = res.headers.get(
          "X-Pagination-Total-Count"
        );
        if (this.mysteryCampaign.length > 0) {
          this.mysteryCampaign.forEach((item) => {
            if (item.status == 1) {
              item.statusString = "Active";
            } else {
              item.statusString = "Inactive";
            }

            item.show = false;
            item.statusString = (item.status == 1) ? "Active" : "Inactive";
            if (new Date(item.start_date) >= new Date()) {
              item.show = true;
            }
          });
        }
      }, err => {
        console.log(err);
      })
  }
  changeStatus(item: MysteryCampaignModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateMysteryCampaign + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getAllMysteryCampaign();
      });
  }


  showlanguageModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }
  goToAdd(data?) {
    this.route.navigate(["/", "hubAdmin", "add-edit-mystery-campaign", data.id]);
  }
  paginationClick(pageNumber) {

    this.page = pageNumber;
    this.getAllMysteryCampaign();
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
